import { resendVerificationEmail } from '../../../modules/account/api';

export const studentResendVerificationEmailUseCase = (email: string): Promise<void> => {
  return resendVerificationEmail(email);
};